<template>
  <v-container>
    <div class="row justify-content-center">
      <div class="col-md-12 col-lg-12">
        <v-layout justify-center align-center class="m-2">
      <v-flex xs12 sm12 md12 lg12 xl12>
        <VueFaqAccordion fontColor="#696969" id="faq" :items="myItems" />
      </v-flex>
    </v-layout>
      </div>
    </div
  ></v-container>
</template>




<script>
import { mapGetters } from "vuex";
import VueFaqAccordion from "vue-faq-accordion";
export default {
  name: "Faq",
  components: {
    VueFaqAccordion,
  },

  data() {
    return {
      myItems: [],
      color: null,
    };
  },
  created() {
    this.$store.dispatch("setCurrentRoute", this.$route.name);
    this.getItems;
    this.getcolor;
  },
  watch: {
    isdark(val) {
      this.getcolor;
      console.log(this.color);
    },
  },
  computed: {
    getLocaleMessages() {
      return this.$root.$i18n.messages[this.langLocal];
    },
    getItems() {
      this.myItems = [
        {
          title: "How many time zones are there in all?",
          value:
            "Given a 24-hour day and 360 degrees of longitude around the Earth",
          category: this.getLocaleMessages["faq"],
        },
        {
          title: "How long is a day and year on Venus?",
          value:
            "Venus takes 224.7 Earth days to complete one orbit around the Sun.",
          category: this.getLocaleMessages["faq"],
        },
        {
          title: "What animal smells like popcorn?",
          value: "Binturongs smell like popcorn.",
          category: this.getLocaleMessages["faq"],
        },
        {
          title: "How many time zones are there in all?",
          value:
            "Given a 24-hour day and 360 degrees of longitude around the Earth",
          category: this.getLocaleMessages["faq"],
        },
      ];
      return this.myItems;
    },
    getcolor() {
      if (this.isdark == true) {
        this.color = "white";
      } else {
        this.color = "black";
      }
    },
    ...mapGetters(["current_route", "langLocal", "isdark"]),
  },

  methods: {},
};
</script>
<style scoped>
#site-header {
  margin-top: 500px;
}
.faq {
  width: 100% !important;
}
.faq-wrapper {
  max-width: 100%;
}
#faq {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>